module.exports = __webpack_public_path__ + "img/potion_img_01.6ff7e3d2.png";